// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"445":"bff53ae6","497":"4bdeed12"}[chunkId] + ".css";
};